import { render, staticRenderFns } from "./PendingRequestComponent.vue?vue&type=template&id=654fbb41&lang=pug&"
import script from "./PendingRequestComponent.vue?vue&type=script&lang=js&"
export * from "./PendingRequestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports